import styled, { css } from "styled-components";
import theme from "~/styles/theme";
import { Grid } from "@material-ui/core";
import { Button } from "~/components/elements";

export const ValorTotalLabel = styled.div`
  color: var(--Neutral-Gray-900, #1B1B19);
  font-size: 20px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px; /* 120% */
`

export const ValorTotal = styled.div`
  color: var(--cores-0D5BA8, #0D5BA8);
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
`
export const CaptchaHolder = styled.div`
  > div > div > div {
    margin: 0 auto;
  }
`;

export const GuardeNota = styled.div`
  color: var(--cores-000000, #000);
  leading-trim: both;
  text-edge: cap;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%; /* 18.4px */
`

export const FormHolder = styled.div`
  padding: 0 16px;
  margin: 0 auto;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0;
    max-width: 496px;
  }

  h2 {
    color: ${theme.palette.neutral.primary.key};
  }

  p {
    color: ${theme.palette.brand.primary.dark};
    span {
      cursor: pointer;
      font-family: ${theme.typography.secondaryFont};
      text-decoration: underline;
    }
    strong {
      font-family: ${theme.typography.secondaryFont};
    }
  }
`;

export const ButtonsGrid = styled(Grid)`
  width: 100%;
  div,
  button {
    width: 100%;

    &:nth-child(2) {
      margin-bottom: 17px;
    }
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    button {
      width: 100%;
      max-width: 240px;

      &:nth-child(2) {
        margin-bottom: 0;
      }
    }
  }
`;

export const FormLimiter = styled.form`
  padding: 0 16px;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    margin: 0 auto;
    padding: 0;
  }

  #purchaseFieldFormInvoice {
    border-radius: 8px;
  }

  strong {
    font-weight: 700;
  }
`;

export const FieldCouponWarning = styled.div`
  display: flex;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.feedback.error.key};
  }

  strong {
    color: ${theme.palette.feedback.error.key};
  }

  svg {
    margin-right: 8px;
  }
`;

export const Alert = styled.div`
  display: flex;
  width: 100%;
  background-color: ${theme.palette.feedback.error.light};
  padding: 24px;
  align-items: center;
  border-radius: 8px;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
  }

  p,
  strong {
    color: ${theme.palette.feedback.error.key};
  }

  svg {
    margin-right: 16px;
  }
`;

export const AlertText = styled.div``;

export const UploadDropZone = styled.div`
  padding: 30px;
  border: 2px dashed ${theme.palette.neutral.primary.key};
  background-color: ${theme.palette.neutral.primary.medium};
  border-radius: 8px;
  text-align: center;

  p {
    font-family: ${theme.typography.fontFamilyRegular};
  }

  p,
  strong {
    color: ${theme.palette.neutral.primary.key};
  }

  button {
    background-color: ${theme.palette.neutral.primary.light};
    border-color: ${theme.palette.neutral.primary.light};
    width: 100%;
  }
`;

export const FileName = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  padding: 16px 0;
  border-radius: 8px;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 24px;
  }

  strong {
    margin: 0 8px 8px 0px;
  }
`;

export const ProductsHolder = styled.div`
  margin-bottom: 32px;
  p {
    color: ${theme.palette.neutral.primary.key};
    font-weight: 500;
  }
`;

export const ProductTop = styled.div`
  display: flex;
  font-weight: 700;
  margin-bottom: 32px;

  p {
    color: ${theme.palette.neutral.primary.key};
  }

  img {
    margin-right: 16px;
    width: 100%;
    max-width: 64px;
  }
`;

export const ProductBottomValue = styled.div`
  color: var(--cores-000000, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const ProductBottomLabel = styled.div`
  color: var(--cores-000000, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`

export const ProductBottom = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    flex-direction: row;
  }

  > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &.fake {
    flex-direction: row;

    div {
      flex-direction: column;
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 200px;
    margin-top: 0;
  }
`;

export const RemoveProductBtn = styled.span`
  background: transparent;
  border: none;
  display: flex;
  cursor: pointer;

  strong {
    font-weight: 400;
    color: ${theme.palette.feedback.error.key};
    margin-left: 8px;
  }
`;

export const EditProductBtn = styled.span`
  background: transparent;
  border: none;
  display: flex;
  cursor: pointer;

  strong {
    font-weight: 400;
    color: ${theme.palette.brand.primary.key};
    margin-left: 8px;
  }
`;

export const QuestionIcon = styled.div`
  position: absolute;
  right: 0;
  top: 3px;

  svg {
    cursor: pointer;
  }
`;

export const InputHolder = styled.div`
  position: relative;
`;

export const Product = styled.div`
  padding: 16px;
  border: 1px solid ${theme.palette.brand.primary.key};
  background-color: ${theme.palette.neutral.primary.light};
  border-radius: 8px;
  margin-bottom: 16px;
`;

export const AddProductListButton = styled(Button)`
  width: 100%;
`;

export const TotalProducts = styled.div`
  border-radius: 8px;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.palette.neutral.primary.light};

  h5 {
    color: ${theme.palette.neutral.primary.key};
    font-weight: 700;
    font-size: 16px;
  }

  h4 {
    color: ${theme.palette.brand.primary.key};
    font-weight: 500;
    font-size: 20px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      font-size: 24px;
    }
  }
`;

export const Skeleton = styled.div`
  width: 64px;
  height: 64px;
  background-color: #d9d9d9;
  margin-right: 16px;
  border-radius: 9px;
`;

export const MinimumValue = styled.div`
  color: #DB3939;
  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-bottom: 32px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 40px;
  }

  > div {
    margin-right: 8px;
  }
`;

export const LabelRadio = styled.div`
  display: flex;
  span {
    ${(props) =>
      props.error &&
      css`
        margin-top: 0;
      `}
  }

  p {
    ${(props) =>
      props.error &&
      css`
        color: ${theme.palette.feedback.error.key} !important;
      `}
    a {
      ${(props) =>
        props.error &&
        css`
          color: ${theme.palette.feedback.error.key} !important;
        `}
    }
  }
`;

export const RadioStyleTitle = styled.div`
  font-weight: 500;
`;
